export default {
  title: {
    list: "グループ一覧",
    create: "グループ作成",
    edit: "グループ編集"
  },
  errors: {
    getGroupList: "グループ一覧の取得に失敗しました。"
  },
  csv: {
    input: "グループの入力"
  },
  groupName: "グループ名",
  comment: "コメント",
  list: {
    id: "ID",
    operationOfficeName: "運営会社名",
    status: "ステータス",
    updatedAt: "最終更新日",
    updatedBy: "最終更新者",
    edit: "編集"
  },
  confirmationModal: {
    enable: "有効",
    disable: "無効",
    statusConfirm: "グループを{ status }にします。よろしいですか？"
  },
  form: {
    managementOffice: "管理会社",
    operationOffice: "運営会社",
    groupType: "グループ種類",
    driver: "ドライバー",
    vehicle: "車両",
    affiliation: "所属",
    list: "一覧",
    selected: "選択済"
  }
}
